module.exports = __webpack_public_path__ + "static/egg-rttd-help-screen-659c73ccda4b14c8520533369cf5e2b1.png";